import React, {useEffect, useState} from "react";
import { withRouter } from "react-router-dom";
import { useRestaurant } from '../contexts/restaurant.context';

function ScrollToTopFloatingButton({history}) {
    const restaurant = useRestaurant();

    const {theme} = restaurant ?? {};
    
    const [scrollToTop, setScrollToTop] = useState(false);

    useEffect(() => {
        if (!scrollToTop) { return; }

        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            setScrollToTop(false);
        }, 150);

    }, [scrollToTop]);
    
    const handleScrollToTop = () => {
        setScrollToTop(true);
    };

    if (!restaurant) {
        return null;
    }
    
    return (
        <div className="btn-scroll-top d-none d-xl-block">
            <button
                type="button"
                onClick={handleScrollToTop}
                className="btn btn-cart"
                style={{
                    color: theme?.floating_order_button_font_color,
                    backgroundColor: theme?.floating_order_button_background_color,
                    borderColor: theme?.floating_order_button_background_color,
                }}
            >
                <i className="fas fa-shopping-cart"></i> View Order
            </button>
        </div>
    );
}

export default withRouter(ScrollToTopFloatingButton);